angular.module('eatself')
.filter('truncate', function() {
  return function(str,length,omission = '...') {
    return _.truncate(str,{length,separator:' ',omission});
  };
})
